import script from "./Message.vue?vue&type=script&setup=true&lang=ts"
export * from "./Message.vue?vue&type=script&setup=true&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=2d2021d6&lang=scss"

const __exports__ = script;

export default __exports__